import React, { Fragment } from 'react';
import moment from 'moment';
import { Insight } from '../types/insight';
import listDetail from '../../../../assets/img/listDetail.png';

interface ActionLogItem {
  when_created: string;
  action: string | null;
  first_name?: string;
  last_name?: string;
  reason?: string;
  conditional_answer?: string;
  created_by: {
    first_name: string;
    last_name: string;
  };
}

interface AssignedPersonInfo {
  first_name?: string;
  last_name?: string;
}

interface ExtendedInsight extends Insight {
  action_log?: ActionLogItem[];
  assignedPersonInfo?: AssignedPersonInfo;
}

interface ActionLogProps {
  item?: ExtendedInsight;
  short?: boolean;
}

function ActionLog(props: ActionLogProps): JSX.Element {
  function getAction(
    action_status: string | null,
    first_name?: string,
    last_name?: string,
  ): string {
    if (action_status === 'R') {
      return 'Assigned to ' + first_name + ' ' + last_name;
    } else if (
      action_status === 'E' ||
      action_status === 'A' ||
      action_status === 'D' ||
      action_status === 'C'
    ) {
      return 'Closed';
    } else if (action_status === null) {
      return 'Review in progress';
    } else if (action_status === 'I') {
      return 'Ignored';
    } else if (action_status === 'S') {
      return 'Ceased';
    } else {
      return '';
    }
  }

  let actions: ActionLogItem[] = [];

  if (props.item) {
    actions =
      props.item.action_log
        ?.slice()
        .sort((a, b) => {
          const c = moment(new Date(a.when_created));
          const d = moment(new Date(b.when_created));
          return d.valueOf() - c.valueOf();
        })
        .splice(0, 5) || [];
  }

  let uKey = 0;

  const actionElements = actions.map((e) => {
    return (
      <Fragment key={uKey++}>
        <div className="flexVertWrap">
          <div>
            <label
              className={`txtInsightNotesLine1 ${props.short ? 'insightNotesShort' : ''}`}
            >
              {getAction(
                e.action,
                e.first_name || props?.item?.assignedPersonInfo?.first_name,
                e.last_name || props?.item?.assignedPersonInfo?.last_name,
              ) + (e.reason ? ', ' + e.reason : '')}
              {e.conditional_answer && e.conditional_answer !== ''
                ? e.conditional_answer + ', '
                : ''}
            </label>
          </div>
          <div>
            <label
              className={`txtInsightNotesLine2 ${props.short ? 'insightNotesShort' : ''}`}
            >
              {e.created_by.first_name + ' ' + e.created_by.last_name} -{' '}
              {moment(e.when_created).format('DD MMM YY')}
            </label>
          </div>
        </div>
      </Fragment>
    );
  });

  return (
    <>
      <div className="flexHorizWrap">
        <div>
          <img
            alt="listDetail"
            className="imgInsightDetails"
            src={listDetail}
          />
        </div>
        <div>
          <label id="lblActionLog" className="txtLeft">
            Action log
          </label>
        </div>
      </div>
      {actionElements.length > 0 ? actionElements : 'No actions'}
    </>
  );
}

export { ActionLog };
